import { useMutation, useQuery } from "@tanstack/react-query";
import { locationMatchingApi, ConfirmMatchDto } from "../../../utilities/apiInstances/location-matching-api";

export const useLocationMatching = () => {
  const getUnmatchedLocationsQuery = useQuery({
    queryKey: ["locationMatching", "unmatchedLocations"],
    queryFn: () => locationMatchingApi.getUnmatchedLocations(),
  });

  const getUnmatchedRelationshipsQuery = useQuery({
    queryKey: ["locationMatching", "unmatchedRelationships"],
    queryFn: () => locationMatchingApi.getUnmatchedRelationships(),
  });

  const useCubbyFacilitiesQuery = (relationshipId: number | string | null) => {
    return useQuery({
      queryKey: ["locationMatching", "cubbyFacilities", relationshipId],
      queryFn: () => locationMatchingApi.getCubbyFacilities(relationshipId as number | string),
      enabled: !!relationshipId,
    });
  };

  const confirmMatchMutation = useMutation({
    mutationFn: (dto: ConfirmMatchDto) => locationMatchingApi.confirmMatch(dto),
  });

  return {
    getUnmatchedLocationsQuery,
    getUnmatchedRelationshipsQuery,
    useCubbyFacilitiesQuery,
    confirmMatchMutation,
  };
};
